import { AppView, TitlebarView, VideoView, YoutubeVideoView, ButtonView, ProgressImagePathView } from "@gaming/srvg-classes-core";
import { MatchdayArea } from "../MatchdayArea";

/**
 * Main view class for the VBL micro version.
 */
export class MicroView extends AppView{
    /**
     * The usual titlebar view.
     */
    titlebar: TitlebarView;
    /**
     * The usual video view. Starts inactive in this view.
     */
    videoView: VideoView;
    /**
     * The usual matchday area, this time without odds.
     */
    matchdayArea: MatchdayArea;
    /**
     * A view that encapsulates the Youtube video player, which plays a specifically designed video from our Youtube
     * channel. Saves bandwidth and server load on our streaming servers when VBL micro is not being actively used.
     */
    youtubeVideoView: YoutubeVideoView;
    /**
     * A big button that overlays the Youtube video. Clicking the button causes the Youtube video (and the button)
     * to disappear and the regular match video to start playing.
     */
    playButton: ButtonView;

    /**
     * Creates an instance of this class.
     */
    constructor(options){
        options = options || {};
        options.selector = options.selector || '#vbl_container';
        super(options);

        /******************* initialize views ************************/

        this.titlebar = this.addSubView( new TitlebarView( { selector: '#titlebar' } ) );

        var hdChannel = null;
        if( srvg.videooptions.alt_videobasename ) {
            if( !srvg.featuresInstances.getStartWithHd() ) {
                hdChannel = srvg.videooptions.serverurl+srvg.videooptions.videobasename;
            }
            else {
                hdChannel = srvg.videooptions.serverurl+srvg.videooptions.alt_videobasename;
            }
        }

        // Setting the videoHandlers order for the videoView
        var videoHandlers = [];
        if (srvg.Player.getWorkingStreamType() == 'flash') {
            videoHandlers = ['flash', 'hls', 'html5'];
        } else {
            videoHandlers = ['hls', 'flash', 'html5'];
        }

        this.videoView = this.addSubView( new VideoView( {
            channel: srvg.videooptions.defaultchannel,
            playerOptions: {
                hdChannel: hdChannel,
                hdswitch: null,
                overlays: '#overlay_container',
                useLiveplayer: true,
                hidePlayButton: false,
                hideStopButton: true,
                hide:'display',
                muted: true,
                vod: false,
                loglevel: 0,
                ui: {
                    enabled: false,
                    videoControls : false,
                    fullscreen : false,
                    controlBarHideDelay: 3
                },
                poster: srvg.url.image+'video/poster.png',
                noButton: false,
                autoplay: true,
                swf: srvg.url.webroot+'liveplayer/srplayer.swf',
                videoHandlers: videoHandlers,
                smoothTransition: false,
                micro: true

            }
        }, srvg ) );

        this.matchdayArea = this.addSubView( new MatchdayArea({
            selector: '#matchdayarea_0',
            offset: 0,
            hasMatchdayPicker: true
        }) );

        var progressImagePath = <ProgressImagePathView>this.matchdayArea.calltoactionView.progressView; // TS < 1.6
        // var progressImagePath = this.matchdayArea.calltoactionView.progressView as SrvgProgressImagePath; TS >= 1.6

        progressImagePath.setPath( [
            { x: 45, y:9 }, { x: 70, y:9 }, { x: 80, y:25 }, { x: 70, y:39 }, { x: 9, y:39 }, { x: 9, y:9 },
            { x: 45, y:9 }
        ] );
        progressImagePath.setBackground( srvg.url.image+'calltoaction_micro/cta-clock-gradient.png' );
        progressImagePath.setSize( 91, 50 );

        var disableYoutubeVideo = srvg.featuresInstances.getDisableYoutubeVideo() || typeof srvg.videooptions.youtubeId === typeof undefined || ! srvg.videooptions.youtubeId;

        if( disableYoutubeVideo ) {
            $('#youtubevideo_container').addClass('disabled');
            this.youtubeVideoView = this.addSubView( new YoutubeVideoView( {}) );
        }
        else {
            this.youtubeVideoView = this.addSubView( new YoutubeVideoView( { selector:'#youtubevideo_container', videoId: srvg.videooptions.youtubeId } ) );
        }
        this.playButton = this.addSubView( new ButtonView( { selector: '#playbutton' } ) );
    }
}